import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import * as React from 'react';
import classNames from 'classnames';
import TimeColumn from './time-column';
import { formatDate, newDate, setTime as utilSetTime } from '../../utils/date-fns';
import Context from '../../context';
import useStateMemo from '../../hooks/use-state-memo';
import { leftPad } from '../../utils';
import Header from '../header/header'; // export interface TimePanelProps extends SharedTimeProps {
//   format?: string
//   // active?: boolean
// }

function shouldUnitsUpdate(prevUnits, nextUnits) {
  if (prevUnits.length !== nextUnits.length) return true;

  for (var i = 0; i < prevUnits.length; i += 1) {
    if (prevUnits[i].disabled !== nextUnits[i].disabled) return true;
  }

  return false;
}

function TimePanel(props) {
  var context = React.useContext(Context);
  var prefixCls = context.prefixCls,
      dateValue = context.dateValue,
      onSelect = context.onSelect,
      _context$originHour = context.originHour,
      originHour = _context$originHour === void 0 ? -1 : _context$originHour,
      _context$minute = context.minute,
      minute = _context$minute === void 0 ? -1 : _context$minute,
      _context$second = context.second,
      second = _context$second === void 0 ? -1 : _context$second,
      _context$hours = context.hours,
      rawHours = _context$hours === void 0 ? [] : _context$hours,
      _context$minutes = context.minutes,
      minutes = _context$minutes === void 0 ? [] : _context$minutes,
      _context$seconds = context.seconds,
      seconds = _context$seconds === void 0 ? [] : _context$seconds,
      disabledTimePanel = context.disabledTimePanel;
  var picker = props.picker,
      _props$format = props.format,
      format = _props$format === void 0 ? 'HH:mm:ss' : _props$format,
      showHour = props.showHour,
      showMinute = props.showMinute,
      showSecond = props.showSecond,
      _props$use12Hours = props.use12Hours,
      use12Hours = _props$use12Hours === void 0 ? false : _props$use12Hours,
      hideDisabledOptions = props.hideDisabledOptions; // console.log(rawHours)

  if (disabledTimePanel) {
    originHour = -1;
    minute = -1;
    second = -1;
  } // const bodyOperationRef = React.useRef<BodyOperationRef>()
  // ======================= Keyboard =======================
  // const [activeColumnIndex, setActiveColumnIndex] = React.useState(-1)
  // debugger


  var value = dateValue; // if (mergedActivePickerIndex === 0) {
  //   value = rangeValue![0]
  // } else if (mergedActivePickerIndex === 1) {
  //   value = rangeValue![1]
  // }

  var columns = [];
  var columnPrefixCls = "".concat(prefixCls, "-time");
  var isPM; // const originHour = value ? getHours(value) : -1

  var hour = originHour; // const minute = value ? getMinutes(value) : -1
  // const second = value ? getSeconds(value) : -1

  var setTime = function setTime(isPM, newHour, newMinute, newSecond) {
    var _a, _b, _c;

    var date = value || newDate();

    var _hour = newHour > -1 ? newHour : (_a = _findInstanceProperty(rawHours).call(rawHours, function (n) {
      return !n.disabled;
    })) === null || _a === void 0 ? void 0 : _a.value;

    var _minute = newMinute > -1 ? newMinute : (_b = _findInstanceProperty(minutes).call(minutes, function (n) {
      return !n.disabled;
    })) === null || _b === void 0 ? void 0 : _b.value;

    var _second = newSecond > -1 ? newSecond : (_c = _findInstanceProperty(seconds).call(seconds, function (n) {
      return !n.disabled;
    })) === null || _c === void 0 ? void 0 : _c.value;

    if (!_hour && _hour !== 0) {
      _hour = -1;
    }

    if (!_minute && _minute !== 0) {
      _minute = -1;
    }

    if (!_second && _second !== 0) {
      _second = -1;
    } // 所有时或分或秒 disabled 时，返回空（date-time）


    if (_hour > -1 && _minute > -1 && _second > -1) {
      date = utilSetTime(date, {
        hour: !use12Hours || !isPM ? _hour : _hour + 12,
        minute: _minute,
        second: _second
      });
      return date;
    }

    return null;
  }; // const rawHours = generateUnits(0, 23, hourStep, disabledHours && disabledHours())


  var memorizedRawHours = useStateMemo(function () {
    return rawHours;
  }, rawHours, shouldUnitsUpdate);

  if (use12Hours) {
    isPM = hour >= 12;
    hour %= 12;
  }

  var _React$useMemo = React.useMemo(function () {
    if (!use12Hours) {
      return [false, false];
    }

    var AMPMDisabled = [true, true];
    memorizedRawHours.forEach(function (_ref) {
      var disabled = _ref.disabled,
          hourValue = _ref.value;
      if (disabled) return;

      if (hourValue >= 12) {
        AMPMDisabled[1] = false;
      } else {
        AMPMDisabled[0] = false;
      }
    });
    return AMPMDisabled;
  }, [use12Hours, memorizedRawHours]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      AMDisabled = _React$useMemo2[0],
      PMDisabled = _React$useMemo2[1];

  var hours = React.useMemo(function () {
    var _context;

    if (!use12Hours) return memorizedRawHours;
    return _mapInstanceProperty(_context = _filterInstanceProperty(memorizedRawHours).call(memorizedRawHours, isPM ? function (hourMeta) {
      return hourMeta.value >= 12;
    } : function (hourMeta) {
      return hourMeta.value < 12;
    })).call(_context, function (hourMeta) {
      var hourValue = hourMeta.value % 12;
      var hourLabel = hourValue === 0 ? '12' : leftPad(hourValue, 2);
      return _extends(_extends({}, hourMeta), {
        label: hourLabel,
        value: hourValue
      });
    });
  }, [use12Hours, memorizedRawHours, isPM]); // const minutes = generateUnits(0, 59, minuteStep, disabledMinutes && disabledMinutes(originHour))
  // const seconds = generateUnits(0, 59, secondStep, disabledSeconds && disabledSeconds(originHour, minute))

  function addColumnNode(condition, node, columnValue, units, onColumnSelect) {
    if (condition !== false) {
      columns.push({
        node: /*#__PURE__*/React.cloneElement(node, {
          prefixCls: columnPrefixCls,
          value: columnValue,
          onSelect: onColumnSelect,
          units: units,
          selectValue: value,
          hideDisabledOptions: hideDisabledOptions
        })
      });
    }
  }

  addColumnNode(showHour, /*#__PURE__*/React.createElement(TimeColumn, {
    key: "hour"
  }), hour, hours, function (num) {
    var time = setTime(isPM, num, minute, second);

    if (time) {
      onSelect(time, 'mouse');
    }
  });
  addColumnNode(showMinute, /*#__PURE__*/React.createElement(TimeColumn, {
    key: "minute"
  }), minute, minutes, function (num) {
    var time = setTime(isPM, hour, num, second);

    if (time) {
      onSelect(time, 'mouse');
    }
  });
  addColumnNode(showSecond, /*#__PURE__*/React.createElement(TimeColumn, {
    key: "second"
  }), second, seconds, function (num) {
    var time = setTime(isPM, hour, minute, num);

    if (time) {
      onSelect(time, 'mouse');
    }
  });
  var PMIndex = -1;

  if (typeof isPM === 'boolean') {
    PMIndex = isPM ? 1 : 0;
  }

  addColumnNode(use12Hours === true, /*#__PURE__*/React.createElement(TimeColumn, {
    key: "12hours"
  }), PMIndex, [{
    label: 'AM',
    value: 0,
    disabled: AMDisabled
  }, {
    label: 'PM',
    value: 1,
    disabled: PMDisabled
  }], function (num) {
    var time = setTime(!!num, hour, minute, second);

    if (time) {
      onSelect(time, 'mouse');
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-time"), {// [`${panelPrefixCls}-active`]: active,
    })
  }, picker !== 'time' ? /*#__PURE__*/React.createElement(Header, {
    className: "".concat(prefixCls, "-time-header")
  }, !disabledTimePanel && value ? formatDate(value, format) : null) : null, /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-content"), {// [`${panelPrefixCls}-active`]: active,
    })
  }, _mapInstanceProperty(columns).call(columns, function (_ref2) {
    var node = _ref2.node;
    return node;
  })));
}

export default TimePanel;